import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from "lodash";
import { sendAsync } from "../../app/applicationSlice";
import { RootState, RootThunkApi } from "../../app/store";
import { Page, startPageOf } from "../../models/page";
import * as Rc from "../../models/recipe";
import { Recipe } from "../../models/recipe";
import * as Rt from "../../models/retail";
import { Retail } from "../../models/retail";
import * as SRc from "../../services/recipe";
import * as SRt from "../../services/retail";
import {
  GetRetailListParams,
  JuheReturnPremiumParams,
  JuheReturnPremium,
  editNameFn,
  editNameFnParams,
  recipeAdapterMsgParams,
  getRecipeAdapterMsg, updateTreatmentType, updateTreatmentTypeParams, getSaveDisease, saveDiseaseParams,
  selectDrugTradeSubItemParams,
  getSelectDrugTradeSubItemList,
  getPatientInsuranceTradeCnt,
} from '../../services/retail'

interface RetailStatus {
  currentTab: string
  treatmentId?: string
  page: Page<Retail>
}

const initialState = {
  currentTab: '',
  page: startPageOf(),
} as RetailStatus

export const getRetailList = createAsyncThunk<
  Page<Retail>,
  GetRetailListParams,
  RootThunkApi<Page<Retail>>
>('retail/getRetailListStatus', async (params, api) => {
  return sendAsync(SRt.getRetailList(params), api).then(
    (data: Record<string, never>) => {
      return {
        current: data.current,
        size: data.size,
        total: data.total,
        items: _.chain(data.records)
          .map((r) => Rt.fromJson(r))
          .value(),
      }
    }
  )
})

export const getRetailListNew = createAsyncThunk<
  Page<Retail>,
  GetRetailListParams,
  RootThunkApi<Page<Retail>>
>('retail/getRetailListStatus', async (params, api) => {
  return sendAsync(SRt.getRetailListNew(params), api).then(
    (data: Record<string, never>) => {
      return {
        current: data.current,
        size: data.size,
        total: data.total,
        items: _.chain(data.records)
          .map((r) => Rt.fromJson(r))
          .value(),
      }
    }
  )
})

export const getJuHeRetailList = createAsyncThunk<
  Page<Retail>,
  GetRetailListParams,
  RootThunkApi<Page<Retail>>
>('retail/getJuHeRetailList', async (params, api) => {
  return sendAsync(SRt.getRetailList(params), api).then(
    (data: Record<string, never>) => {
      return {
        current: data.current,
        size: data.size,
        total: data.total,
        items: _.chain(data.records)
          .map((r) => Rt.fromJson(r))
          .value(),
      }
    }
  )
})

export const getRecipeLists = createAsyncThunk<
  Recipe[],
  SRc.RecipeListParams,
  RootThunkApi<Recipe[]>
>('retail/getRecipeListStatus', async (params, api) => {
  return sendAsync(SRc.getRecipeLists(params), api).then(
    (data: Record<string, never>) =>
      _.chain(data.records)
        .map((r) => Rc.fromJson(r))
        .value()
  )
})


export const getRecipeList = createAsyncThunk<
  Recipe[],
  string,
  RootThunkApi<Recipe[]>
>('retail/getRecipeListStatus', async (treatmentId, api) => {
  return sendAsync(SRc.getRecipeList(treatmentId), api).then(
    (data: Record<string, never>) =>
      _.chain(data.records)
        .map((r) => Rc.fromJson(r))
        .value()
  )
})

const retailSlice = createSlice({
  name: 'retail',
  initialState,
  reducers: {
    setCurrentTab: (state, action: PayloadAction<string>) => {
      state.currentTab = action.payload
    },
    setTreatmentId: (state, action: PayloadAction<string | undefined>) => {
      state.treatmentId = action.payload
      state.currentTab = '0'
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getRetailListNew.fulfilled, (state, action) => {
      state.page = action.payload
    })
  },
})

// 聚合支付退费
export const JuhePremium = createAsyncThunk<
  any,
  JuheReturnPremiumParams,
  RootThunkApi
>('confirm/JuhePremium', async (params, api) => {
  return sendAsync(JuheReturnPremium(params), api)
})
// 药品零售-修改患者姓名
export const editName = createAsyncThunk<any, editNameFnParams, RootThunkApi>(
  'confirm/editName',
  async (params, api) => {
    return sendAsync(editNameFn(params), api)
  }
)


export const updateTreatmentTypeAsync = createAsyncThunk<any,updateTreatmentTypeParams, RootThunkApi>(
  'confirm/updateTreatmentType',
  async (params, api) => {
    return sendAsync(updateTreatmentType(params), api)
  }
)

export const getRecipeAdapterMsgAsync = createAsyncThunk<any,recipeAdapterMsgParams, RootThunkApi>(
  'confirm/getRecipeAdapterMsg',
  async (params, api) => {
    return sendAsync(getRecipeAdapterMsg(params), api)
  }
)

// 修改保存疾病
export const getSaveDiseaseAsync = createAsyncThunk<any,saveDiseaseParams, RootThunkApi>(
  'confirm/getSaveDiseaseAsync',
  async (params, api) => {
    return sendAsync(getSaveDisease(params), api)
  }
)

// 查询医保结算数据
export const getSelectDrugTradeSubItemListAsync = createAsyncThunk<any,selectDrugTradeSubItemParams, RootThunkApi>(
  'confirm/getSelectDrugTradeSubItemListAsync',
  async (params, api) => {
    return sendAsync(getSelectDrugTradeSubItemList(params), api)
  }
)

export const getPatientInsuranceTradeCntAsync = createAsyncThunk<void,any, RootThunkApi>(
  'confirm/getPatientInsuranceTradeCntAsync',
  async (params, api) => {
    return sendAsync(getPatientInsuranceTradeCnt(params), api)
  }
)

export const { setCurrentTab, setTreatmentId } = retailSlice.actions;

export const selectCurrentTab = (state: RootState): string =>
  state.retail.currentTab;

export const selectTreatmentId = (state: RootState): string | undefined =>
  state.retail.treatmentId;

export const selectRetailPage = (state: RootState): Page<Retail> =>
  state.retail.page;

export default retailSlice.reducer;
